module.exports = __webpack_public_path__ + "img/group_invite.c0b4a375.png";